import { axios } from '@/api/common'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  LocationCreateModel,
  LocationUpdateModel,
  LocationUpdateSchema,
} from './mutation.schema'

export async function CreateLocation(data: LocationCreateModel): Promise<void> {
  await axios.post('/api/warehouse/locations', data)
}

export const useCreateLocationMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: CreateLocation,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['locations'] })
    },
  })
}

export async function updateLocation(data: LocationUpdateModel): Promise<void> {
  const patch = LocationUpdateSchema.parse(data)
  await axios.put(`/api/warehouse/locations/${data.id}`, patch)
}

export const useUpdateLocationMutation = (id: number) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationKey: ['locations', 'update', id],
    mutationFn: updateLocation,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['locations'] })
    },
  })
}

export const useDeleteLocationMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => axios.delete(`/api/warehouse/locations/${id}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['locations'] })
    },
  })
}
